import { useState } from 'react';

import { renderHtmlWithTeX } from '../../../../utils/RenderQuestionWithTex';
import { cn } from '../../../../utils/tailwindMerge';

type QuestionOptionProps = {
  id: number;
  text: string;
  onClick: () => void;
  isSelected: boolean;
};

const QuestionOption = ({
  id,
  text,
  onClick,
  isSelected
}: QuestionOptionProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div
      className={cn(
        'flex w-full items-center gap-1 rounded-lg text-left font-Primary md:rounded-xl'
      )}
    >
      <button
        onBlur={handleBlur}
        onFocus={handleFocus}
        onClick={onClick}
        className={cn(
          'font-gully group flex w-full items-center gap-1 rounded-md bg-gamma px-2 py-1 text-left text-lg font-medium text-blue_a12 hover:border-beta hover:text-primary md:gap-2 md:rounded-lg md:border-2 md:px-4 md:py-2',
          isSelected
            ? 'border-[0.5px] border-beta text-primary'
            : 'hover:shadow-boxShadowSeven'
        )}
      >
        <span
          className={`${isSelected ? 'border-primary' : 'border-[#BCBAB6] bg-gamma group-hover:border-beta group-hover:bg-[#CEDDFF]'} mr-1 flex h-3 w-3 flex-shrink-0 items-center justify-center rounded-full border p-[0.1rem] text-sm md:mr-2 md:h-4 md:w-4 md:border-2 md:text-base`}
        >
          {isSelected && (
            <span className='h-full w-full rounded-full bg-primary '></span>
          )}
        </span>
        <span className='flex-1 break-words text-sm md:text-base'>
          {renderHtmlWithTeX(text, false)}
        </span>
      </button>
    </div>
  );
};

export default QuestionOption;
